import { useEffect } from "react";
import { api } from "@/lib/api";

const PINGED_KEY = "civichearth_pwa_install_pinged";

// F&F batch (2026-02): anonymous PWA-install beacon. Chromium browsers fire
// `appinstalled` once when the user completes the install prompt — we ping a
// no-PII counter endpoint (day only; no user id / IP / UA) so the admin
// Launch Health panel can show installs. One ping per device (localStorage
// guard). iOS never fires this event — Add to Home Screen is silent — so the
// tile undercounts Apple devices by design (documented in PRD).
export default function PwaInstallPing() {
  useEffect(() => {
    const onInstalled = () => {
      if (localStorage.getItem(PINGED_KEY)) return;
      localStorage.setItem(PINGED_KEY, "1");
      api.sendPwaInstall().catch(() => {});
    };
    window.addEventListener("appinstalled", onInstalled);
    return () => window.removeEventListener("appinstalled", onInstalled);
  }, []);
  return null;
}
